import { withTranslation } from "react-i18next";

import RedeemtionList from './RedeemtionList';

export default withTranslation(undefined, { withRef: true })(RedeemtionList);